/**
 * readerVersion.js - which build of the screenshot reader is running.
 *
 * 🔴 A VERSION THE USER CAN SEE. Sep 1 2026: two rounds were lost to "still
 * broken" reports against code that had already been fixed, because a phone had
 * cached the old bundle and nothing on the screen could tell old code from a
 * real bug. A reader that cannot say which version it is turns every report
 * into a guess. Bump this whenever the parsing changes.
 *
 * 🔴 IT LIVES ALONE, IN ITS OWN FILE, ON PURPOSE. The obvious home is
 * screenshotRead.js, and the first cut put it there. But the panel that shows
 * this string renders BEFORE any image is uploaded, so importing it from
 * screenshotRead would pull that module, its matcher and the whole player pool
 * into the main bundle and quietly undo the dynamic import the feature is built
 * around. One string in one file costs nothing.
 */
export const READER_VERSION = "reader 12";
